import { FunctionComponent, useEffect, useState } from 'react'
import { Location, Navigate, useLocation } from 'react-router-dom'
import StaffList from './StaffList/staffList'
import StaffProfile from './StaffProfile/staffProfile'
import { StaffWithLinks } from '@/types/Staff'

interface StaffHandlerProps {
    staffsListData: StaffWithLinks[]
    refetchAllStaffList: () => Promise<void>
    canDraft: boolean
    canRead: boolean
}

const StaffHandler: FunctionComponent<StaffHandlerProps> = ({
    staffsListData,
    refetchAllStaffList,
    canDraft,
    canRead
}: StaffHandlerProps) => {
    const urlDaycare: Location = useLocation()

    const paramDaycare: URLSearchParams = new URLSearchParams(urlDaycare.search)

    const [staffId, setStaffId] = useState<number | null>(
        paramDaycare.get('profile') === null ? null : Number(paramDaycare.get('profile'))
    )

    useEffect((): void => {
        const param: string | null = paramDaycare.get('profile')
        setStaffId(!param ? null : Number(param))
    }, [urlDaycare])

    return staffId !== null ? (
        <StaffProfile staffId={staffId} staffsListData={staffsListData} refetchAllStaffList={refetchAllStaffList} />
    ) : canRead ? (
        <StaffList staffsListData={staffsListData} refetchAllStaffList={refetchAllStaffList} canDraft={canDraft} />
    ) : (
        <Navigate to='/' replace />
    )
}

export default StaffHandler
